import { render } from "./PestPredictor.vue?vue&type=template&id=162e7981&scoped=true"
import script from "./PestPredictor.vue?vue&type=script&lang=js"
export * from "./PestPredictor.vue?vue&type=script&lang=js"

import "./PestPredictor.vue?vue&type=style&index=0&id=162e7981&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162e7981"]])

export default __exports__